if (!customElements.get('tag-filter')) {
  customElements.define(
    'tag-filter',
    class TagFilter extends HTMLSelectElement {
      constructor() {
        super();
    
        this.updateWidth();
        this.addEventListener('change', this.onChange);
      }
    
      updateWidth() {
        const value = this.options[this.selectedIndex].text;
        const width = theme.getElementWidth(this, value);
        this.style.setProperty('--width', `${width}px`);
      }
    
      onChange() {
        this.updateWidth();
        window.location.href = this.value;
      }
    }, { extends: 'select' }
  );
}

if (!customElements.get('blog-tag-filters')) {
  customElements.define(
    'blog-tag-filters',
    class BlogTagFilters extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onChange);
      }

      onChange(event) {
        if (!event.target.matches('select[data-blog-tag-select]')) return;

        const blogUrl = this.dataset.blogUrl;
        const handles = [];

        this.querySelectorAll('select[data-blog-tag-select]').forEach((select) => {
          const handle = select.options[select.selectedIndex]?.dataset.tagHandle;
          if (handle) handles.push(handle);
        });

        let url = blogUrl;
        if (handles.length === 1) {
          url = `${blogUrl}/tagged/${handles[0]}`;
        } else if (handles.length > 1) {
          url = `${blogUrl}/tagged/${handles.join('+')}`;
        }

        window.location.href = url;
      }
    }
  );
}
